import Header from "./header";

window.addEventListener("DOMContentLoaded", () => {
    setTimeout(() => {
        new Header();
    }, 1);
});